module.exports = __webpack_public_path__ + "static/how_wide_extra-debb1c59ea11c7a21af3bea12823d843.svg";